<template>
  <div class="progress-box">
    <div ref="progress" id="progress"></div>
  </div>
</template>

<script>
export default {
  name: 'baseProgress',
  data () {
    return {
      activeColor: '#409eff'
    }
  },
  props: {
    percentage: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: '#409eff'
    }
  },
  watch: {
    color: function (value) {
      this.activeColor = value
    },
    percentage: {
      handler () {
        let dom = this.$refs.progress
        if (dom) {
          dom.style.width = this.percentage + '%'
          dom.style.background = this.color
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style>
.progress-box {
  width: 96%;
  height: 4px;
  margin: 6px auto 0;
  border-radius: 5px;
  background: #e6e6e6;
}

#progress {
  height: 100%;
  width: 1%;
  background: #409eff;
  border-radius: 5px;
}
</style>
